import React, { useState, useEffect, useContext } from 'react';
import { AuthContext } from '../context/AuthContext';

function FunktionenSection() {
    return (
        <div className="space-y-6">
            <section className="bg-gray-50 dark:bg-[#1e1e1e] rounded-lg p-6 border border-gray-200 dark:border-gray-800">
                <div className="flex items-center gap-3 mb-4">
                    <svg className="w-6 h-6 text-plantlix-500" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <rect x="3" y="3" width="18" height="18" rx="2" />
                        <path d="M9 9h6v6H9z" />
                    </svg>
                    <h2 className="text-xl font-bold text-gray-800 dark:text-gray-100">Dashboard</h2>
                </div>
                <div className="space-y-3 text-gray-700 dark:text-gray-300">
                    <div>
                        <h3 className="font-semibold text-gray-900 dark:text-gray-100 mb-1">Übersicht</h3>
                        <p>Das Dashboard ist dein zentraler Ausgangspunkt. Hier siehst du alle Pflanzen und kannst sie filtern und durchsuchen.</p>
                    </div>
                    <div>
                        <h3 className="font-semibold text-gray-900 dark:text-gray-100 mb-1">Filter & Suche</h3>
                        <ul className="list-disc pl-5 space-y-1">
                            <li><strong>Suche:</strong> Nach botanischem oder deutschem Namen suchen</li>
                            <li><strong>Kategorie:</strong> Filterung nach Pflanzenkategorien</li>
                            <li><strong>Lernstatus:</strong> Filterung nach "Nicht gelernt", "In Arbeit" oder "Gelernt"</li>
                            <li><strong>Pflanzenliste:</strong> Filterung nach GALABAUER oder FRIEDHOFSGAERTNER</li>
                            <li><strong>Favoriten:</strong> Nur favorisierte Pflanzen anzeigen</li>
                            <li><strong>Fällige Karten:</strong> Zeigt Karten, die im SRS wiederholt werden müssen</li>
                            <li><strong>Zwischenprüfung:</strong> Filterung nach Zwischenprüfungs-Pflanzen</li>
                        </ul>
                    </div>
                    <div>
                        <h3 className="font-semibold text-gray-900 dark:text-gray-100 mb-1">Fortschrittsanzeige</h3>
                        <p>Fortschrittsbalken pro Kategorie zeigen deinen Lernstand auf einen Blick.</p>
                    </div>
                </div>
            </section>

            <section className="bg-gray-50 dark:bg-[#1e1e1e] rounded-lg p-6 border border-gray-200 dark:border-gray-800">
                <div className="flex items-center gap-3 mb-4">
                    <svg className="w-6 h-6 text-plantlix-500" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
                        <polyline points="3.27 6.96 12 12.01 20.73 6.96" />
                        <line x1="12" y1="22.08" x2="12" y2="12" />
                    </svg>
                    <h2 className="text-xl font-bold text-gray-800 dark:text-gray-100">Quiz & Lernen</h2>
                </div>
                <div className="space-y-3 text-gray-700 dark:text-gray-300">
                    <div>
                        <h3 className="font-semibold text-gray-900 dark:text-gray-100 mb-1">Quiz-Modi</h3>
                        <ul className="list-disc pl-5 space-y-1">
                            <li><strong>Karteikarten-Modus:</strong> Karte umdrehen und Antwort eingeben</li>
                            <li><strong>Multiple-Choice:</strong> Aus mehreren Antwortmöglichkeiten wählen</li>
                            <li><strong>Bild → Botanischer Name:</strong> Bild ansehen, botanischen Namen eingeben</li>
                            <li><strong>Botanischer Name → Deutsch:</strong> Botanischen Namen sehen, deutschen Namen eingeben</li>
                        </ul>
                    </div>
                    <div>
                        <h3 className="font-semibold text-gray-900 dark:text-gray-100 mb-1">Spaced Repetition System (SRS)</h3>
                        <p>Plantlix nutzt das SM-2 Algorithmus für optimale Lernzeiten:</p>
                        <ul className="list-disc pl-5 space-y-1 mt-2">
                            <li>Richtige Antworten erhöhen das Wiederholungsintervall</li>
                            <li>Falsche Antworten verkürzen das Intervall</li>
                            <li>Das System passt sich deinem Lernfortschritt an</li>
                            <li>Karten werden automatisch zum optimalen Zeitpunkt wiederholt</li>
                        </ul>
                    </div>
                    <div>
                        <h3 className="font-semibold text-gray-900 dark:text-gray-100 mb-1">"Heute lernen"</h3>
                        <p>Startet automatisch mit fälligen Karten basierend auf deinem SRS-Status.</p>
                    </div>
                </div>
            </section>

            <section className="bg-gray-50 dark:bg-[#1e1e1e] rounded-lg p-6 border border-gray-200 dark:border-gray-800">
                <div className="flex items-center gap-3 mb-4">
                    <svg className="w-6 h-6 text-plantlix-500" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                        <circle cx="12" cy="7" r="4" />
                    </svg>
                    <h2 className="text-xl font-bold text-gray-800 dark:text-gray-100">Profil & Statistiken</h2>
                </div>
                <div className="space-y-3 text-gray-700 dark:text-gray-300">
                    <div>
                        <h3 className="font-semibold text-gray-900 dark:text-gray-100 mb-1">Statistiken</h3>
                        <ul className="list-disc pl-5 space-y-1">
                            <li>Gesamtanzahl gelernte Pflanzen</li>
                            <li>Anzahl fällige Reviews</li>
                            <li>Fortschritt in Prozent</li>
                            <li>XP (Erfahrungspunkte) und Level</li>
                            <li>Verteilung nach Lernstatus</li>
                            <li>SRS-Boxen Übersicht</li>
                            <li>7-Tage-Vorschau</li>
                        </ul>
                    </div>
                    <div>
                        <h3 className="font-semibold text-gray-900 dark:text-gray-100 mb-1">Profil-Einstellungen</h3>
                        <ul className="list-disc pl-5 space-y-1">
                            <li>Benutzername ändern</li>
                            <li>E-Mail-Adresse ändern</li>
                            <li>Passwort ändern</li>
                            <li>Avatar hochladen</li>
                            <li>Standard-Pflanzenliste festlegen</li>
                        </ul>
                    </div>
                </div>
            </section>

            <section className="bg-gray-50 dark:bg-[#1e1e1e] rounded-lg p-6 border border-gray-200 dark:border-gray-800">
                <div className="flex items-center gap-3 mb-4">
                    <svg className="w-6 h-6 text-plantlix-500" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                        <circle cx="9" cy="7" r="4" />
                        <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
                        <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                    </svg>
                    <h2 className="text-xl font-bold text-gray-800 dark:text-gray-100">Plant Duel</h2>
                </div>
                <div className="space-y-3 text-gray-700 dark:text-gray-300">
                    <p>Spiele Quiz-Duelle gegen andere Nutzer!</p>
                    <div>
                        <h3 className="font-semibold text-gray-900 dark:text-gray-100 mb-1">Spiel erstellen</h3>
                        <ol className="list-decimal pl-5 space-y-1">
                            <li>Erstelle ein neues Duell</li>
                            <li>Teile den Einladungscode mit einem Freund</li>
                            <li>Warte bis dein Gegner beitritt</li>
                        </ol>
                    </div>
                    <div>
                        <h3 className="font-semibold text-gray-900 dark:text-gray-100 mb-1">Spielablauf</h3>
                        <ul className="list-disc pl-5 space-y-1">
                            <li>Buzzern, um zu antworten</li>
                            <li>In begrenzter Zeit die richtige Antwort eingeben</li>
                            <li>Bei falscher Antwort hat der Gegner eine Steal-Chance</li>
                            <li>Punkte werden pro Runde vergeben</li>
                            <li>Best-of-Modus entscheidet das Duell</li>
                        </ul>
                    </div>
                </div>
            </section>

            <section className="bg-gray-50 dark:bg-[#1e1e1e] rounded-lg p-6 border border-gray-200 dark:border-gray-800">
                <div className="flex items-center gap-3 mb-4">
                    <svg className="w-6 h-6 text-plantlix-500" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                        <polyline points="17 8 12 3 7 8" />
                        <line x1="12" y1="3" x2="12" y2="15" />
                    </svg>
                    <h2 className="text-xl font-bold text-gray-800 dark:text-gray-100">Bild-Upload</h2>
                </div>
                <div className="space-y-3 text-gray-700 dark:text-gray-300">
                    <p>Lade eigene Bilder für Pflanzen hoch und verwalte sie.</p>
                    <ul className="list-disc pl-5 space-y-1">
                        <li>Öffne eine Pflanze in der Detailansicht</li>
                        <li>Klicke auf "Bilder hochladen"</li>
                        <li>Wähle ein oder mehrere Bilder aus</li>
                        <li>Füge optional Beschriftungen hinzu</li>
                        <li>Verwalte deine hochgeladenen Bilder im Profil</li>
                    </ul>
                </div>
            </section>

            <section className="bg-gray-50 dark:bg-[#1e1e1e] rounded-lg p-6 border border-gray-200 dark:border-gray-800">
                <div className="flex items-center gap-3 mb-4">
                    <span className="text-2xl">🏆</span>
                    <h2 className="text-xl font-bold text-gray-800 dark:text-gray-100">Achievements & Gamification</h2>
                </div>
                <div className="space-y-3 text-gray-700 dark:text-gray-300">
                    <ul className="list-disc pl-5 space-y-1">
                        <li><strong>Achievements:</strong> Sammle Badges für verschiedene Leistungen</li>
                        <li><strong>XP-System:</strong> Verdiene Erfahrungspunkte beim Lernen</li>
                        <li><strong>Level:</strong> Steige auf und erreiche höhere Level</li>
                        <li><strong>Tägliche Herausforderungen:</strong> Komplettiere tägliche Aufgaben</li>
                        <li><strong>Fortschrittsbalken:</strong> Verfolge deinen Fortschritt visuell</li>
                    </ul>
                </div>
            </section>
        </div>
    );
}

function AnleitungSection() {
    return (
        <div className="space-y-6">
            <div className="bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-lg p-6">
                <h2 className="text-xl font-bold text-gray-800 dark:text-gray-100 mb-4 flex items-center gap-2">
                    <span>📖</span>
                    <span>Erste Schritte</span>
                </h2>
                <ol className="list-decimal pl-5 space-y-3 text-gray-700 dark:text-gray-300">
                    <li>
                        <strong>Registrierung:</strong> Erstelle einen Account oder nutze Google Sign-In
                    </li>
                    <li>
                        <strong>E-Mail bestätigen:</strong> Bestätige deine E-Mail-Adresse (wichtig für Passwort-Reset)
                    </li>
                    <li>
                        <strong>Profil einrichten:</strong> Wähle deine Standard-Pflanzenliste (GALABAUER oder FRIEDHOFSGAERTNER)
                    </li>
                    <li>
                        <strong>Erste Pflanzen lernen:</strong> Nutze das Dashboard, um Pflanzen zu durchsuchen
                    </li>
                    <li>
                        <strong>Quiz starten:</strong> Beginne mit einem Quiz im Karteikarten-Modus
                    </li>
                </ol>
            </div>

            <div className="bg-plantlix-50 dark:bg-plantlix-900/20 border border-plantlix-200 dark:border-plantlix-800 rounded-lg p-6">
                <h2 className="text-xl font-bold text-gray-800 dark:text-gray-100 mb-4 flex items-center gap-2">
                    <span>✅</span>
                    <span>Lernstrategien</span>
                </h2>
                <div className="space-y-3 text-gray-700 dark:text-gray-300">
                    <div>
                        <h3 className="font-semibold text-gray-900 dark:text-gray-100 mb-2">Für Anfänger:</h3>
                        <ul className="list-disc pl-5 space-y-1">
                            <li>Beginne mit "Nicht gelernt" Pflanzen</li>
                            <li>Nutze den Karteikarten-Modus für erste Wiederholungen</li>
                            <li>Markiere schwierige Pflanzen als Favoriten</li>
                            <li>Konzentriere dich auf eine Kategorie nach der anderen</li>
                        </ul>
                    </div>
                    <div>
                        <h3 className="font-semibold text-gray-900 dark:text-gray-100 mb-2">Für Fortgeschrittene:</h3>
                        <ul className="list-disc pl-5 space-y-1">
                            <li>Nutze "Heute lernen" für optimale Wiederholungen</li>
                            <li>Fokussiere auf fällige Karten</li>
                            <li>Nutze Multiple-Choice für schnelleres Training</li>
                            <li>Nutze Duell-Modus für zusätzliche Motivation</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
}

function FehlerSection() {
    return (
        <div className="space-y-6">
            <div className="bg-yellow-50 dark:bg-yellow-900/20 border border-yellow-200 dark:border-yellow-800 rounded-lg p-6">
                <h2 className="text-xl font-bold text-gray-800 dark:text-gray-100 mb-4 flex items-center gap-2">
                    <span>⚠️</span>
                    <span>Häufige Probleme & Lösungen</span>
                </h2>

                <div className="space-y-4">
                    <div className="bg-white dark:bg-[#1a1a1a] rounded-lg p-4 border border-yellow-200 dark:border-yellow-800">
                        <h3 className="font-semibold text-gray-900 dark:text-gray-100 mb-2">Problem: Seite lädt nicht / Fehler 500</h3>
                        <ul className="list-disc pl-5 space-y-1 text-gray-700 dark:text-gray-300">
                            <li>Lösung: Seite neu laden (F5 oder Strg+R)</li>
                            <li>Cache leeren (Strg+Shift+R oder Strg+F5)</li>
                            <li>Browser-Cache leeren</li>
                            <li>Anderen Browser versuchen</li>
                        </ul>
                    </div>

                    <div className="bg-white dark:bg-[#1a1a1a] rounded-lg p-4 border border-yellow-200 dark:border-yellow-800">
                        <h3 className="font-semibold text-gray-900 dark:text-gray-100 mb-2">Problem: Anmeldung funktioniert nicht</h3>
                        <ul className="list-disc pl-5 space-y-1 text-gray-700 dark:text-gray-300">
                            <li>Lösung: Prüfe Benutzername und Passwort</li>
                            <li>Nutze "Passwort zurücksetzen" falls vergessen</li>
                            <li>Prüfe, ob E-Mail-Adresse bestätigt wurde</li>
                            <li>Versuche Google Sign-In als Alternative</li>
                        </ul>
                    </div>

                    <div className="bg-white dark:bg-[#1a1a1a] rounded-lg p-4 border border-yellow-200 dark:border-yellow-800">
                        <h3 className="font-semibold text-gray-900 dark:text-gray-100 mb-2">Problem: Bilder werden nicht angezeigt</h3>
                        <ul className="list-disc pl-5 space-y-1 text-gray-700 dark:text-gray-300">
                            <li>Lösung: Warte kurz - Bilder werden nachgeladen</li>
                            <li>Prüfe Internetverbindung</li>
                            <li>Seite neu laden</li>
                            <li>Browser-Erweiterungen deaktivieren (Ad-Blocker)</li>
                        </ul>
                    </div>

                    <div className="bg-white dark:bg-[#1a1a1a] rounded-lg p-4 border border-yellow-200 dark:border-yellow-800">
                        <h3 className="font-semibold text-gray-900 dark:text-gray-100 mb-2">Problem: Quiz startet nicht</h3>
                        <ul className="list-disc pl-5 space-y-1 text-gray-700 dark:text-gray-300">
                            <li>Lösung: Prüfe Filtereinstellungen - möglicherweise keine passenden Pflanzen</li>
                            <li>Wähle größeren Deck Size</li>
                            <li>Entferne zu viele Filter</li>
                            <li>Wechsle Pflanzenliste</li>
                        </ul>
                    </div>

                    <div className="bg-white dark:bg-[#1a1a1a] rounded-lg p-4 border border-yellow-200 dark:border-yellow-800">
                        <h3 className="font-semibold text-gray-900 dark:text-gray-100 mb-2">Problem: Duell kann nicht erstellt werden</h3>
                        <ul className="list-disc pl-5 space-y-1 text-gray-700 dark:text-gray-300">
                            <li>Lösung: Gast-User können keine Duells erstellen - bitte registriere dich</li>
                            <li>Stelle sicher, dass du angemeldet bist</li>
                            <li>Prüfe Internetverbindung</li>
                        </ul>
                    </div>

                    <div className="bg-white dark:bg-[#1a1a1a] rounded-lg p-4 border border-yellow-200 dark:border-yellow-800">
                        <h3 className="font-semibold text-gray-900 dark:text-gray-100 mb-2">Problem: Statistiken stimmen nicht</h3>
                        <ul className="list-disc pl-5 space-y-1 text-gray-700 dark:text-gray-300">
                            <li>Lösung: Seite neu laden - Statistiken werden aktualisiert</li>
                            <li>Warte kurz nach Quiz-Abschluss</li>
                            <li>Prüfe Filter in der Statistik-Ansicht</li>
                        </ul>
                    </div>

                    <div className="bg-white dark:bg-[#1a1a1a] rounded-lg p-4 border border-yellow-200 dark:border-yellow-800">
                        <h3 className="font-semibold text-gray-900 dark:text-gray-100 mb-2">Problem: E-Mail-Verifizierung</h3>
                        <ul className="list-disc pl-5 space-y-1 text-gray-700 dark:text-gray-300">
                            <li>Lösung: Prüfe Spam-Ordner</li>
                            <li>Nutze "E-Mail erneut senden" im Profil</li>
                            <li>Prüfe E-Mail-Adresse auf Tippfehler</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
}

function ChangelogSection({ appVersion }) {
    const changes = [
        {
            version: appVersion,
            date: '10. Mai 2026',
            features: [
                'Admin-Dashboard 2.0: Interaktive Diagramme (Lernstatus-Donut & 7-Tage-Aktivität) statt reiner Zahlen.',
                'QR-Vernetzung: Jeder Nutzer hat nun einen persönlichen QR-Code und Einladungslink zum direkten Teilen via WhatsApp/Telegram.',
                'Mobile Wetter-Integration: Temperatur-Anzeige im Header und klickbarer Wetter-Eintrag im mobilen Menü.',
                'PdW-Optimierung: Kompakteres Layout der "Pflanze der Woche"-Liste für bessere Übersicht auf allen Geräten.',
                'Zertifikats-Redesign: Offizielle Urkunden mit Siegel, Seriennummer und optimierter Typografie.'
            ]
        },
        {
            version: 'v1.5.0',
            date: 'April 2026',
            features: [
                'Full Integration "Sign in with Apple" (Web & App)',
                'AES-256 Verschlüsselung für sensible Ausbildungsdaten',
                'Optimierte HTTPS-Sicherheit für Proxy-Deployments',
                'Verbesserte Datenintegrität bei verschlüsselten Berichten',
                'Fix: Referer-Header Problematik bei der Anmeldung gelöst'
            ]
        },
        {
            version: 'v1.4.0',
            date: 'März 2026',
            features: [
                'Verbessertes Pflanzen-Bestiary mit neuer Zoom-Funktion',
                'Optimierte Darstellung auf Tablets und großen Bildschirmen',
                'Erhöhte Stabilität und Fehlerbehebungen beim Quiz',
                'Auswertungsseite im Profil zeigt jetzt gesammelte Statistiken zuverlässig an',
                'Neue Scrollbar im Plantlix-Design (CI)',
                'Verbesserungen im Ausbildungsnachweis (Automatische Weiterleitung)'
            ]
        },
        {
            version: 'v1.3.0',
            date: 'Februar 2026',
            features: [
                'Neue PDF-Exportfunktion für Ausbildungsnachweise',
                'Pflanze der Woche: Erweiterte Ansichten und Druckversion',
                'Wetterdaten werden nun automatisch für Berichte bezogen',
                'Verbesserte Responsivität der Karten',
                'Performance-Updates im Bestiary'
            ]
        },
        {
            version: 'v1.2.0',
            date: 'Frühjahr 2026',
            features: [
                'Einführung des Ausbilder-Dashboards',
                'Neue Quizze: Multiple-Choice, Lernkarten und Erkennung',
                'Community-Features: Sniggeln, Freunde und Badges'
            ]
        }
    ];

    return (
        <div className="space-y-6 animate-fadeIn">
            <div className="space-y-6">
                {changes.map((release, index) => (
                    <div key={index} className="bg-white dark:bg-[#1a1a1a] p-6 rounded-xl shadow-sm border border-gray-200 dark:border-gray-800">
                        <div className="flex items-baseline justify-between mb-4 border-b border-gray-100 dark:border-gray-800 pb-3">
                            <h2 className="text-2xl font-bold text-plantlix-600 dark:text-plantlix-500">
                                {release.version}
                            </h2>
                            <span className="text-sm font-medium text-gray-500 dark:text-gray-400 bg-gray-100 dark:bg-gray-800 px-3 py-1 rounded-full">
                                {release.date}
                            </span>
                        </div>
                        <ul className="space-y-3">
                            {release.features.map((feature, fIndex) => (
                                <li key={fIndex} className="flex flex-start gap-3 text-gray-700 dark:text-gray-300">
                                    <span className="text-plantlix-500 mt-1">✔</span>
                                    <span>{feature}</span>
                                </li>
                            ))}
                        </ul>
                    </div>
                ))}
            </div>
            
            <div className="text-center p-6 bg-plantlix-50 dark:bg-plantlix-900/20 rounded-xl border border-plantlix-100 dark:border-plantlix-800">
                <p className="text-plantlix-800 dark:text-plantlix-300 font-medium">
                    Hast du Feedback oder Wünsche für zukünftige Updates?
                </p>
                <p className="text-sm text-plantlix-500 dark:text-plantlix-400 mt-2">
                    Nutze die Kontakt-Funktion oben, um uns zu kontaktieren.
                </p>
            </div>
        </div>
    );
}function KontaktSection({ form, setForm, onSubmit, isSubmitting, success, error }) {
    return (
        <div className="space-y-6">
            <h2 className="text-xl font-bold text-gray-800 dark:text-gray-100 flex items-center gap-2">
                <span>✉️</span>
                <span>Kontakt & Feature-Wünsche</span>
            </h2>

            {success && (
                <div className="bg-plantlix-50 dark:bg-plantlix-900/20 border border-plantlix-200 dark:border-plantlix-800 rounded-lg p-4">
                    <p className="text-plantlix-800 dark:text-plantlix-300">✅ {typeof success === 'string' ? success : 'Deine Nachricht wurde erfolgreich versendet. Wir melden uns schnellstmöglich bei dir.'}</p>
                </div>
            )}

            {error && (
                <div className="bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-lg p-4">
                    <p className="text-red-800 dark:text-red-300">❌ {error}</p>
                </div>
            )}

            <form onSubmit={onSubmit} className="bg-gray-50 dark:bg-[#1e1e1e] rounded-lg p-6 border border-gray-200 dark:border-gray-800 space-y-4">
                <div>
                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                        Art der Anfrage
                    </label>
                    <select
                        value={form.type}
                        onChange={(e) => setForm({ ...form, type: e.target.value })}
                        className="w-full p-3 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-[#1a1a1a] text-gray-900 dark:text-gray-100 focus:ring-2 focus:ring-plantlix-500 focus:border-plantlix-500"
                    >
                        <option value="support">Support-Anfrage</option>
                        <option value="feature">Feature-Wunsch</option>
                        <option value="bug">Bug-Report</option>
                        <option value="feedback">Feedback</option>
                    </select>
                </div>

                <div>
                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                        Betreff *
                    </label>
                    <input
                        type="text"
                        value={form.subject}
                        onChange={(e) => setForm({ ...form, subject: e.target.value })}
                        required
                        className="w-full p-3 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-[#1a1a1a] text-gray-900 dark:text-gray-100 focus:ring-2 focus:ring-plantlix-500 focus:border-plantlix-500"
                        placeholder="Kurze Beschreibung..."
                    />
                </div>

                <div>
                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                        Nachricht *
                    </label>
                    <textarea
                        value={form.message}
                        onChange={(e) => setForm({ ...form, message: e.target.value })}
                        required
                        rows={8}
                        className="w-full p-3 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-[#1a1a1a] text-gray-900 dark:text-gray-100 focus:ring-2 focus:ring-plantlix-500 focus:border-plantlix-500 resize-none"
                        placeholder="Beschreibe dein Anliegen, deinen Feature-Wunsch oder den Fehler..."
                    />
                </div>

                <div className="bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-lg p-4">
                    <p className="text-sm text-blue-800 dark:text-blue-300">
                        💡 <strong>Hinweis:</strong> Deine Nachricht wird direkt vom Server versendet. Deine Benutzerinformationen werden automatisch hinzugefügt. Maximal 5 Anfragen pro Stunde.
                    </p>
                </div>

                <button
                    type="submit"
                    disabled={isSubmitting}
                    className="w-full px-6 py-3 bg-plantlix-500 hover:bg-plantlix-600 text-white rounded-lg font-medium shadow-sm hover:shadow-md transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
                >
                    {isSubmitting ? (
                        <>
                            <div className="animate-spin rounded-full h-4 w-4 border-2 border-white border-t-transparent"></div>
                            <span>Wird versendet...</span>
                        </>
                    ) : (
                        <>
                            <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                                <polyline points="22,6 12,13 2,6" />
                            </svg>
                            <span>Nachricht senden</span>
                        </>
                    )}
                </button>
            </form>

            <div className="bg-plantlix-50 dark:bg-plantlix-900/20 border border-plantlix-200 dark:border-plantlix-800 rounded-lg p-6">
                <h3 className="font-semibold text-gray-900 dark:text-gray-100 mb-2">Direkter Kontakt</h3>
                <p className="text-gray-700 dark:text-gray-300 mb-3">
                    Alternativ kannst du uns auch direkt per E-Mail kontaktieren:
                </p>
                <a
                    href="mailto:frankberger85@gmail.com?subject=Plantlix%20Support-Anfrage"
                    className="inline-flex items-center gap-2 px-4 py-2 bg-plantlix-500 hover:bg-plantlix-600 text-white rounded-lg font-medium shadow-sm hover:shadow-md transition-all duration-200"
                >
                    <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                        <polyline points="22,6 12,13 2,6" />
                    </svg>
                    E-Mail schreiben
                </a>
            </div>
        </div>
    );
}

function FAQSection({ appVersion }) {
    const [openFAQ, setOpenFAQ] = useState(null);

    const faqs = [
        {
            q: "Ist Plantlix kostenlos?",
            a: `Ja, Plantlix ist kostenlos nutzbar. Die Plattform wird kontinuierlich weiterentwickelt und befindet sich aktuell in der Version ${appVersion}.`
        },
        {
            q: "Welche Browser werden unterstützt?",
            a: "Plantlix funktioniert mit allen modernen Browsern wie Chrome, Firefox, Safari und Edge. Für die beste Erfahrung empfehlen wir Chrome oder Firefox."
        },
        {
            q: "Kann ich meine Daten exportieren?",
            a: "Derzeit kannst du Pflanzenlisten als PDF exportieren. Weitere Export-Funktionen sind in Planung."
        },
        {
            q: "Was ist der Unterschied zwischen GALABAUER und FRIEDHOFSGAERTNER Liste?",
            a: "Die GALABAUER-Liste enthält Pflanzen für Garten- und Landschaftsbau. Die FRIEDHOFSGAERTNER-Liste enthält speziell Pflanzen für Friedhofsgärtner. Beide Listen können parallel genutzt werden."
        },
        {
            q: "Wie funktioniert das Spaced Repetition System?",
            a: "Das SRS passt die Wiederholungsintervalle basierend auf deinen Antworten an. Richtige Antworten erhöhen das Intervall, falsche verkürzen es. So wirst du immer zum optimalen Zeitpunkt wiederholt."
        },
        {
            q: "Kann ich Plantlix offline nutzen?",
            a: "Nein, Plantlix benötigt eine aktive Internetverbindung, da alle Daten auf dem Server gespeichert werden."
        },
        {
            q: "Wie viele Pflanzen kann ich lernen?",
            a: "Es gibt keine Begrenzung. Du kannst alle verfügbaren Pflanzen in deiner gewählten Liste lernen."
        },
        {
            q: "Was passiert mit meinen Daten bei Löschung des Accounts?",
            a: "Bei Löschung deines Accounts werden alle deine persönlichen Daten und Lernfortschritte gelöscht. Hochgeladene Bilder bleiben erhalten (falls nicht vorher gelöscht)."
        },
        {
            q: "Kann ich mehrere Accounts haben?",
            a: "Ja, du kannst mehrere Accounts erstellen. Jeder Account hat seinen eigenen Lernfortschritt."
        },
        {
            q: "Wie kann ich Fehler melden?",
            a: "Nutze das Kontaktformular im Support-Bereich oder schreibe eine E-Mail an frankberger85@gmail.com mit einer detaillierten Beschreibung des Fehlers."
        }
    ];

    return (
        <div className="space-y-4">
            <h2 className="text-xl font-bold text-gray-800 dark:text-gray-100 flex items-center gap-2">
                <span>❓</span>
                <span>Häufig gestellte Fragen (FAQ)</span>
            </h2>

            <div className="space-y-3">
                {faqs.map((faq, index) => (
                    <div
                        key={index}
                        className="bg-gray-50 dark:bg-[#1e1e1e] rounded-lg border border-gray-200 dark:border-gray-800 overflow-hidden"
                    >
                        <button
                            onClick={() => setOpenFAQ(openFAQ === index ? null : index)}
                            className="w-full p-4 text-left flex items-center justify-between hover:bg-gray-100 dark:hover:bg-[#242424] transition-colors"
                        >
                            <span className="font-semibold text-gray-900 dark:text-gray-100">{faq.q}</span>
                            <svg
                                className={`w-5 h-5 text-gray-500 transition-transform ${openFAQ === index ? 'transform rotate-180' : ''}`}
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                            >
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                            </svg>
                        </button>
                        {openFAQ === index && (
                            <div className="p-4 pt-0 border-t border-gray-200 dark:border-gray-800">
                                <p className="text-gray-700 dark:text-gray-300">{faq.a}</p>
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
}

function SpendenSection() {
    return (
        <div className="space-y-6">
            <h2 className="text-2xl font-bold text-gray-800 dark:text-gray-100 flex items-center gap-3">
                <span className="text-plantlix-500">
                    <svg className="w-8 h-8" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
                    </svg>
                </span>
                Unterstütze Plantlix
            </h2>

            <p className="text-gray-800 dark:text-gray-200 text-lg font-medium leading-relaxed">
                Plantlix hilft Auszubildenden und Interessierten, Pflanzenwissen spielerisch zu vertiefen – mit Fokus auf Prüfungsrelevanz und nachhaltigem Lernerfolg.
            </p>

            <div className="bg-[#CFE2D9] dark:bg-[#2A3B33] rounded-lg p-6 border border-[#B0C4BB] dark:border-[#3D5248]">
                <div className="flex items-start gap-4 mb-4">
                    <svg className="w-6 h-6 text-plantlix-600 dark:text-plantlix-400 mt-1 flex-shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                    </svg>
                    <h3 className="font-bold text-lg text-gray-900 dark:text-gray-100">Wofür deine Spende verwendet wird:</h3>
                </div>

                <ul className="space-y-3 ml-1 text-gray-800 dark:text-gray-200">
                    <li className="flex items-start gap-3">
                        <svg className="w-5 h-5 text-plantlix-600 dark:text-plantlix-400 mt-0.5 flex-shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <polyline points="20 6 9 17 4 12" />
                        </svg>
                        <span>Server-Betrieb und Hosting-Kosten</span>
                    </li>
                    <li className="flex items-start gap-3">
                        <svg className="w-5 h-5 text-plantlix-600 dark:text-plantlix-400 mt-0.5 flex-shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <polyline points="20 6 9 17 4 12" />
                        </svg>
                        <span>Weiterentwicklung der App und neue Features</span>
                    </li>
                    <li className="flex items-start gap-3">
                        <svg className="w-5 h-5 text-plantlix-600 dark:text-plantlix-400 mt-0.5 flex-shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <polyline points="20 6 9 17 4 12" />
                        </svg>
                        <span>Verbesserung der Lerninhalte und Datenqualität</span>
                    </li>
                </ul>
            </div>

            <p className="text-gray-700 dark:text-gray-300 italic font-medium">
                Jeder Beitrag hilft uns, Plantlix weiter zu verbessern und kostenfrei für alle verfügbar zu halten. Vielen Dank für deine Unterstützung! 🌿
            </p>

            <div className="flex justify-center pt-4">
                <a
                    href="https://paypal.me/sterni80"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-3 px-8 py-4 bg-plantlix-500 hover:bg-plantlix-600 text-white font-bold rounded-lg shadow-md hover:shadow-lg transition-all transform hover:-translate-y-0.5"
                >
                    <svg className="w-6 h-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
                    </svg>
                    <span>Jetzt spenden via PayPal</span>
                </a>
            </div>
        </div>
    );
}

const Support = ({ appVersion = 'v2.0' }) => {
    const { fetchWithAuth } = useContext(AuthContext);
    const [activeTab, setActiveTab] = useState('funktionen');
    const [changelog, setChangelog] = useState('');
    const [changelogLoading, setChangelogLoading] = useState(false);
    const [contactForm, setContactForm] = useState({ type: 'support', subject: '', message: '' });
    const [isSubmittingContact, setIsSubmittingContact] = useState(false);
    const [contactSuccess, setContactSuccess] = useState(null);
    const [contactError, setContactError] = useState('');

    // Lade Changelog wenn Tab aktiviert wird
    useEffect(() => {
        if (activeTab === 'changelog' && !changelog && !changelogLoading) {
            loadChangelog();
        }
    }, [activeTab]);

    const loadChangelog = async () => {
        setChangelogLoading(true);
        try {
            const response = await fetch('/api/changelog/');
            if (response.ok) {
                const data = await response.json();
                setChangelog(data.changelog || '');
            } else {
                setChangelog('Changelog konnte nicht geladen werden.');
            }
        } catch (error) {
            console.error('Error loading changelog:', error);
            setChangelog('Fehler beim Laden des Changelogs.');
        } finally {
            setChangelogLoading(false);
        }
    };

    const handleContactSubmit = async (e) => {
        e.preventDefault();
        if (!contactForm.subject.trim() || !contactForm.message.trim()) {
            setContactError('Bitte füllen Sie alle Felder aus.');
            return;
        }

        setIsSubmittingContact(true);
        setContactError('');
        setContactSuccess(false);

        try {
            const response = await fetchWithAuth('/api/contact/', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    type: contactForm.type,
                    subject: contactForm.subject,
                    message: contactForm.message
                })
            });

            let data;
            // Klone den Response, damit wir ihn mehrmals lesen können
            const clonedResponse = response.clone();

            try {
                // Prüfe ob Content-Type JSON ist
                const contentType = response.headers.get('content-type');
                if (contentType && contentType.includes('application/json')) {
                    data = await response.json();
                } else {
                    // Wenn keine JSON-Antwort, Text lesen
                    const text = await clonedResponse.text();
                    console.error('Non-JSON response:', text);
                    throw new Error(`Unerwartete Antwort vom Server (${response.status}): ${text.substring(0, 200)}`);
                }
            } catch (jsonError) {
                // Wenn JSON-Parsing fehlschlägt, versuche Text vom geklonten Response zu lesen
                try {
                    const text = await clonedResponse.text();
                    console.error('JSON parse error:', jsonError, 'Response text:', text);
                    throw new Error(`Server-Fehler (${response.status}): ${text.substring(0, 200)}`);
                } catch (textError) {
                    // Wenn auch das fehlschlägt, nutze die ursprüngliche Fehlermeldung
                    throw new Error(`Server-Fehler (${response.status}): ${jsonError.message}`);
                }
            }

            if (!response.ok) {
                // Erstelle detaillierte Fehlermeldung mit Hilfe-Text
                let errorMsg = data.error || `Fehler beim Versenden der Nachricht (${response.status}).`;
                if (data.help_text) {
                    errorMsg += ` ${data.help_text}`;
                }
                if (data.direct_email) {
                    errorMsg += ` E-Mail: ${data.direct_email}`;
                }
                throw new Error(errorMsg);
            }

            // Erfolg
            setContactForm({ type: 'support', subject: '', message: '' });
            setContactSuccess(data.message || 'Deine Nachricht wurde erfolgreich versendet. Wir melden uns schnellstmöglich bei dir.');
            setTimeout(() => setContactSuccess(null), 8000);

        } catch (error) {
            console.error('Contact form error:', error);
            setContactError(error.message || 'Fehler beim Versenden der Nachricht. Bitte versuche es später erneut.');
        } finally {
            setIsSubmittingContact(false);
        }
    };

    const tabs = [
        { id: 'funktionen', label: 'Funktionen', icon: '📚' },
        { id: 'anleitung', label: 'Anleitung', icon: '📖' },
        { id: 'fehler', label: 'Häufige Fehler', icon: '⚠️' },
        { id: 'changelog', label: 'Changelog', icon: '📝' },
        { id: 'kontakt', label: 'Kontakt', icon: '✉️' },
        { id: 'faq', label: 'FAQ', icon: '❓' },
        { id: 'spenden', label: 'Spenden', icon: '💚' }
    ];

    return (
        <div className="p-3 sm:p-4 md:p-6 lg:p-8 max-w-7xl mx-auto w-full">
            <div className="bg-white dark:bg-[#1a1a1a] rounded-xl shadow-sm border border-gray-200 dark:border-gray-800 overflow-hidden">
                {/* Header */}
                <div className="bg-gradient-to-r from-plantlix-50 to-plantlix-50 dark:from-plantlix-900/20 dark:to-plantlix-900/20 border-b border-gray-200 dark:border-gray-800 p-6">
                    <div className="flex items-center gap-4">
                        <div className="flex-shrink-0">
                            <svg className="w-16 h-16 text-plantlix-500" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <circle cx="12" cy="12" r="10" />
                                <path d="M12 16v-4" />
                                <path d="M12 8h.01" />
                            </svg>
                        </div>
                        <div>
                            <h1 className="text-xl sm:text-2xl md:text-3xl font-bold text-gray-800 dark:text-gray-100 mb-2">Support & Hilfe</h1>
                            <p className="text-gray-600 dark:text-gray-400">Umfassende Anleitung und Support für Plantlix {appVersion}</p>
                        </div>
                    </div>
                </div>

                {/* Tab-Navigation */}
                <div className="border-b border-gray-200 dark:border-gray-800 bg-gray-50 dark:bg-[#1e1e1e]">
                    <div className="flex flex-wrap gap-2 p-4">
                        {tabs.map(tab => (
                            <button
                                key={tab.id}
                                onClick={() => setActiveTab(tab.id)}
                                className={`px-4 py-2 rounded-lg font-medium transition-all ${activeTab === tab.id
                                    ? 'bg-plantlix-500 text-white shadow-sm'
                                    : 'bg-white dark:bg-[#1a1a1a] text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-[#242424]'
                                    }`}
                            >
                                <span className="mr-2">{tab.icon}</span>
                                {tab.label}
                            </button>
                        ))}
                    </div>
                </div>

                {/* Tab-Content */}
                <div className="p-4 sm:p-6 md:p-8">
                    {activeTab === 'funktionen' && <FunktionenSection />}
                    {activeTab === 'anleitung' && <AnleitungSection />}
                    {activeTab === 'fehler' && <FehlerSection />}
                    {activeTab === 'changelog' && (
                        <ChangelogSection
                            changelog={changelog}
                            loading={changelogLoading}
                            onLoad={loadChangelog}
                            appVersion={appVersion}
                        />
                    )}
                    {activeTab === 'kontakt' && (
                        <KontaktSection
                            form={contactForm}
                            setForm={setContactForm}
                            onSubmit={handleContactSubmit}
                            isSubmitting={isSubmittingContact}
                            success={contactSuccess}
                            error={contactError}
                        />
                    )}
                    {activeTab === 'faq' && <FAQSection />}
                    {activeTab === 'spenden' && <SpendenSection />}
                </div>
            </div>
        </div>
    );
}

export default Support;
